jQuery(document).ready(function($) {
	$.navigation = {

		init: function() {
			this.oNavigation = $('.l-navigation');
			this.oOverlay = $('.m-overlay');
			this.oCloser = $('.m-navigation-closer');
			this.oButton = $('.m-navigation-opener');
			this.oButtonClose = $('.m-navigation-opener__closer');

			$.navigation.attachListeners();
		},

		attachListeners: function() {
			$(document).on('click', '.m-navigation-opener', this.onOpen);
			$(document).on('click', '.m-navigation-closer', this.onClose);
			$.navigation.oOverlay.on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', this.onTransitionEnd);
		},

		onOpen: function() {
			$.navigation.oOverlay.css('display', 'block');
			$.navigation.oOverlay.addClass('active');

			$.navigation.oNavigation.css('display', 'block');
			$.navigation.oNavigation.addClass('active');

			$.navigation.oCloser.addClass('active');
			$.navigation.oButton.addClass('active');
			$.navigation.oButtonClose.addClass('active');
		},

		onClose: function() {
			$.navigation.oOverlay.removeClass('active');
			$.navigation.oNavigation.removeClass('active');

			$.navigation.oCloser.removeClass('active');
			$.navigation.oButton.removeClass('active');
			$.navigation.oButtonClose.removeClass('active');
		},

		onTransitionEnd: function() {
			if (!$.navigation.oOverlay.hasClass('active')) {
				$.navigation.oOverlay.css('display', 'none');
			}
		}

	};

});